import { type ClientContext, ContextClient } from '~/services/contextClient';
import AiClientFactory from './aiClient.factory';
import type {
    AiClientInterface,
    AiSuggestionResponse,
    AiSuggestionsResponse,
    QuickBlastParams,
    MessageHubSuggestionsParams,
} from './aiClient.types';
import type { AxiosPromise } from 'axios';

class AiClient extends ContextClient<AiClientInterface> {
    constructor() {
        super(AiClientFactory);
    }

    messageHubSuggestions(
        context: ClientContext,
        params: MessageHubSuggestionsParams
    ): AxiosPromise<AiSuggestionResponse> {
        const client = this.getClient(context);
        return client.messageHubSuggestions(params);
    }

    quickBlastSuggestions(context: ClientContext, params: QuickBlastParams): AxiosPromise<AiSuggestionsResponse> {
        const client = this.getClient(context);
        if (!client.quickBlastSuggestions) {
            throw new Error(`quickBlastSuggestions not supported by ${client.constructor.name}`);
        }
        return client.quickBlastSuggestions(params);
    }

    quickBlastFollowUp(context: ClientContext, campaignId: number): AxiosPromise<AiSuggestionsResponse> {
        const client = this.getClient(context);
        if (!client.quickBlastFollowUp) {
            throw new Error(`quickBlastFollowUp not supported by ${client.constructor.name}`);
        }
        return client.quickBlastFollowUp(campaignId);
    }
}

export default new AiClient();
